<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <page-header title="Zonas"></page-header>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table
            :narrowed="true"
            :bordered="true"
            :data="zonas"
            :paginated="true"
            :per-page="tamanoPagina"
            :current-page.sync="paginaActual"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort="user.id"
            aria-next-label="Siguiente página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
          >
            <b-table-column
              v-slot="props"
              field="id"
              label="ID"
              width="4%"
              class="has-text-centered"
            >
              <span> {{ props.row.id }} </span>
            </b-table-column>
            <b-table-column v-slot="props" field="nombre" label="Nombre Zona">
              <span> {{ props.row.nombre }} </span>
            </b-table-column>
            <b-table-column
              field="esZonaPrincipal"
              label="Zona Principal"
              width="7%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si es la zona principal de la sucursal. Si se selecciona, desactiva demás zonas principales de sucursal."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.esZonaPrincipal)" />
              </template>
            </b-table-column>
            <b-table-column
              field="esZonaPicking"
              label="Zona Picking"
              width="7%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si la zona permite pickear en la sucursal."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.esZonaPicking)" />
              </template>
            </b-table-column>
            <b-table-column
              field="esZonaDespacho"
              label="Zona Despacho"
              width="7%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si es zona de despacho en sucursal. (No implementado)"
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.esZonaDespacho)" />
              </template>
            </b-table-column>
            <b-table-column
              field="esZonaRapida"
              label="Zona Rápida"
              width="7%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si es la zona rápida de la sucursal. Si se selecciona, desactiva demás zonas rápida de sucursal."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.esZonaRapida)" />
              </template>
            </b-table-column>
            <b-table-column
              field="puedePausar"
              label="Pausa pedidos?"
              width="7%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si la zona permite pausar/reanudar pedidos en la sucursal."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.puedePausar)" />
              </template>
            </b-table-column>
            <b-table-column
              field="asignaOtraZona"
              label="Permite asignar en otra zona?"
              width="8%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si la zona permite asignar pedidos a alguien disponible en la zona principal, si no hay nadie disponible en la zona."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.asignaOtraZona)" />
              </template>
            </b-table-column>
            <b-table-column
              field="estaActiva"
              label="Está activa?"
              width="7%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si la zona está activa en la sucursal. Si está inactiva no permitirá asignarle pickeadores."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="definirIcono(props.row.estaActiva)" />
              </template>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="metaPromedio"
              label="Meta tiempo promedio"
              width="8%"
              class="is-pulled-right"
            >
              <span class="is-pulled-right">
                {{ props.row.metaPromedio }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="metaTiempoTope"
              label="Meta % OV bajo tiempo"
              width="8%"
            >
              <span class="is-pulled-right">
                {{ props.row.metaTiempoTope }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              label="Acciones"
              width="12%"
              :centered="true"
            >
              <div class="buttons has-text-centered">
                <b-button
                  class="mr-1"
                  type="is-info"
                  size="is-small"
                  title="Modificar"
                  @click="modificarRegistro(props.row.id)"
                >
                  <b-icon icon="pencil-alt" />
                </b-button>
                <div v-if="props.row.estaActiva">
                  <b-button
                    class="mr-1"
                    type="is-success"
                    size="is-small"
                    title="Impresoras"
                    @click="goForwardHandle(props.row.id)"
                  >
                    <b-icon icon="print" />
                  </b-button>
                  <b-button
                    class="mr-1"
                    type="is-success"
                    size="is-small"
                    title="Ubicaciones"
                    @click="modificarUbicaciones(props.row.id)"
                  >
                    <b-icon icon="sitemap" />
                  </b-button>
                  <b-button
                    class="mr-1"
                    type="is-success"
                    size="is-small"
                    title="Actualizar artículos por zona"
                    @click="actualizarUbicaciones(props.row.id)"
                  >
                    <b-icon icon="sync-alt" />
                  </b-button>
                </div>
              </div>
            </b-table-column>
            <template slot="empty">
              <div class="content has-text-grey has-text-centered">
                <p>No hay registros.</p>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button
            type="is-info"
            icon-left="plus"
            :disabled="!puedeAgregar"
            @click="agregarRegistro"
          >
            Agregar
          </b-button>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalHandle"
    >
      <zona-form
        :modificacion="modificacion"
        :objeto="objeto"
        :bodega="bodega"
        :titulo="tituloForm"
        @close="cerrarModalHandle"
      />
    </b-modal>
    <b-modal
      :active.sync="estaModalUbicacionesAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalUbicacionesHandle"
    >
      <ubicaciones :zona="objeto" @close="cerrarModalUbicacionesHandle" />
    </b-modal>
  </div>
</template>

<script>
import qs from 'qs'

import Ubicaciones from '@/components/mantenedor/zonas/Ubicaciones.vue'
import ZonaForm from '@/components/mantenedor/zonas/ZonaForm.vue'
import PageHeader from '@/components/shared/PageHeader.vue'
import disponibilidadMixin from '@/mixins/disponibilidad.js'
import { ubicacionService, zonaService } from '@/services'

export default {
  name: 'Zonas',
  components: {
    ZonaForm,
    Ubicaciones,
    PageHeader
  },
  mixins: [disponibilidadMixin],
  data() {
    return {
      zonas: [],
      estaModalAbierto: false,
      estaModalUbicacionesAbierto: false,
      paginaActual: 1,
      tamanoPagina: 10,
      tituloForm: null,
      objeto: null,
      modificacion: false
    }
  },
  computed: {
    bodega() {
      return this.$store.state.sesion.bodega.id
    },
    puedeAgregar() {
      return this.bodega
    }
  },
  watch: {
    bodega() {
      this.getZonas()
    }
  },
  created() {
    this.getZonas()
  },
  methods: {
    agregarRegistro() {
      this.tituloForm = 'Agregar Zona'
      this.estaModalAbierto = true
    },
    modificarRegistro(id) {
      this.tituloForm = 'Modificar Zona'
      this.objeto = this.zonas.filter((item) => item.id === id)[0]
      this.modificacion = true
      this.estaModalAbierto = true
    },
    modificarUbicaciones(id) {
      this.tituloForm = 'Modificar Zona'
      this.objeto = this.zonas.filter((item) => item.id === id)[0]
      this.estaModalUbicacionesAbierto = true
    },
    confirmarEliminarRegistro(id) {
      const objeto = this.zonas.filter((item) => item.id === id)[0]
      this.$buefy.dialog.confirm({
        title: 'Quitar zona',
        message: `¿Est&aacute; seguro de <b>quitar</b> la zona <b>${objeto.nombre}</b>?`,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.eliminarRegistro(id)
      })
    },
    eliminarRegistro(id) {
      zonaService
        .deleteZona(id)
        .then(() => {
          this.notificarAccionCompletada('Se eliminó zona correctamente')
          this.getZonas()
        })
        .catch((error) => this.procesarError(error))
    },
    cerrarModalHandle(payload = false) {
      this.estaModalAbierto = false
      this.tituloForm = ''
      this.objeto = null
      this.modificacion = false
      if (payload) {
        this.getZonas()
      }
    },
    cerrarModalUbicacionesHandle(payload) {
      this.estaModalUbicacionesAbierto = false
      if (payload.update) {
        this.actualizarUbicaciones(payload.zonaId)
      }
    },
    getZonas() {
      return zonaService
        .getZonas(this.bodega)
        .then((response) => (this.zonas = response.data))
        .catch((error) => this.procesarError(error))
    },
    goForwardHandle(id) {
      const returnUrl = qs.stringify(
        JSON.parse(localStorage.getItem('parametros'))
      )
      this.$router.push(`/mantenedor/terminales/${id}?${returnUrl}`)
    },
    actualizarUbicaciones(zonaId) {
      return ubicacionService
        .updateUbicaciones(zonaId)
        .then((_) =>
          this.notificarAccionCompletada(
            'Se actualizar artículos por zona correctamente'
          )
        )
        .catch((error) => this.procesarError(error))
    }
  }
}
</script>
